import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolTextField } from '@synergy/components';
import { useEffect, useState } from 'react';

import { ProductFile } from '../../../../../../common/models/product-file';

export interface ProductDetailFilesEditTitleModalProps {
    file?: ProductFile | null;
    onClose: () => void;
    onConfirm: (name: string) => void;
}

export const ProductDetailFilesEditTitleModal = (props: ProductDetailFilesEditTitleModalProps) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(prevValue => props.file?.title ?? prevValue);
    }, [props.file]);

    return (
        <PoolModal
            title={<FormattedMessage id="app.product.detail.files.editTitle" />}
            isVisible={!!props.file}
            handleClose={props.onClose}
            actionChildren={[
                <PoolButton key="1" onClick={props.onClose} styleType="firstLevel" variant="text">
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>,
                <PoolButton key="2" onClick={() => props.onConfirm(value)} styleType="firstLevel">
                    <FormattedMessage id="app.common.save" />
                </PoolButton>,
            ]}
        >
            <PoolTextField
                label={<FormattedMessage id="app.label.title" />}
                value={value}
                onChange={e => setValue(e.target.value)}
                fullWidth={true}
            />
        </PoolModal>
    );
};
